export default "__VITE_ASSET__Do8824w___"